import React, { Suspense } from "react";
import ProtectedRoute from "ProtectedRoute";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";

// Plan K Phase 4 — SpendGuard module routes. Stage 0: dashboard hub showing
// which tier features the org has unlocked. Per-feature pages (Duplicate list,
// Anomaly inbox, AI assistant chat, etc.) land in follow-up phases.
//
// Lane-gated by `lane.spendguard` (Phase 2 derivation) — sidenav hides the
// group entirely when the org has no spendguard_* entitlement.
const SpendGuardDashboard = React.lazy(() => import("spendguard/pages/Dashboard"));

const spendguardRoutes = [
  {
    type: "collapse",
    name: "SpendGuard",
    key: "spendguard-dashboard",
    icon: <SavingsOutlinedIcon />,
    route: "/spendguard",
    laneKey: "lane.spendguard",
    component: (
      <ProtectedRoute>
        <Suspense fallback={null}>
          <SpendGuardDashboard />
        </Suspense>
      </ProtectedRoute>
    ),
    noCollapse: true,
  },
];

export default spendguardRoutes;
